import { EPS, r3 } from './qty.js';

// Skema diskon bertingkat (formulir owner): qty satu pesanan dijumlahkan per (divisi produk, satuan);
// potongan per satuan diambil dari tingkat tertinggi yang min_qty-nya terpenuhi. Produk tanpa divisi = tanpa diskon.

export interface DiscountTier {
  division: string;
  unit: string;
  min_qty: number;
  disc: number;
}

export interface DiscountLine {
  division: string | null | undefined;
  unit: string;
  qty: number;
  price: number;
}

const dkey = (div: unknown, unit: unknown) =>
  `${String(div || '')
    .trim()
    .toLowerCase()}|${String(unit || '')
    .trim()
    .toLowerCase()}`;

/** Diskon per satuan untuk tiap baris (urutan sama dengan `lines`), tidak pernah melebihi harga. */
export function discountsFor(lines: readonly DiscountLine[], tiers: readonly DiscountTier[]): number[] {
  const sorted = [...tiers].sort((a, b) => a.min_qty - b.min_qty);
  const totals = new Map<string, number>();
  for (const l of lines) {
    if (!l.division) continue;
    const k = dkey(l.division, l.unit);
    totals.set(k, r3((totals.get(k) || 0) + (Number(l.qty) || 0)));
  }
  return lines.map((l) => {
    let d = 0;
    if (l.division) {
      const k = dkey(l.division, l.unit);
      const tot = totals.get(k) || 0;
      for (const t of sorted) if (dkey(t.division, t.unit) === k && tot + EPS >= t.min_qty) d = t.disc;
    }
    return Math.min(d, l.price);
  });
}
